import { ThemedText } from '@/components/themed-text';
import packsSnapshot from '@/content/generated/packs.json';
import {
  packRuleRows,
  packServiceRows,
  SEGMENTS_CHECKED_AT,
  type PackSnapshot,
  type SegmentPage,
} from '@/content/seo/segments';
import React from 'react';
import { View } from 'react-native';
import { SemanticTable } from './semantic-table';
import { Reveal, SectionTitle, SeoSection } from './seo-blocks';

const PACKS = (packsSnapshot as { packs: PackSnapshot[] }).packs;

/**
 * "Como fica pronto no seu ramo": os serviços, preços, durações e regras que
 * o assistente de configuração sugere para o ramo, lidos do snapshot dos
 * pacotes da API (`content/generated/packs.json`). É o dado próprio da
 * página; nunca média de mercado.
 */
export function SegmentDefaults({ page }: { page: SegmentPage }) {
  const pack = PACKS.find((item) => item.slug === page.packSlug);
  if (!pack) return null;

  return (
    <SeoSection tone="white">
      <SectionTitle eyebrow="Como fica pronto no seu ramo" title={page.defaultsTitle} />
      <Reveal className="mb-8 max-w-3xl gap-2">
        <ThemedText className="text-base text-neutral-700 md:text-lg">
          Padrões que o assistente da Controlapag sugere para {page.ramo}, conferidos em {SEGMENTS_CHECKED_AT}. Você muda
          tudo quando quiser. Não são médias de mercado.
        </ThemedText>
        <ThemedText className="text-sm text-neutral-500">
          O assistente monta isso na criação da conta, em qualquer plano.
        </ThemedText>
      </Reveal>
      <View className="gap-6">
        <SemanticTable
          caption={`Serviços sugeridos para ${page.ramo}`}
          showCaption
          columns={[{ label: 'Serviço sugerido' }, { label: 'Preço sugerido' }, { label: 'Duração' }, { label: 'Cobrança' }]}
          rows={packServiceRows(pack)}
        />
        <SemanticTable
          caption={`Regras sugeridas para ${page.ramo}`}
          showCaption
          columns={[{ label: 'Regra' }, { label: 'Padrão sugerido' }, { label: 'Em que plano' }]}
          rows={packRuleRows(pack)}
        />
      </View>
    </SeoSection>
  );
}
